<!--
  @template PaginationComponent
  @description
  Bootstrap-style pagination component using Angular v17+ control flow syntax.
  Includes optional navigation buttons, jump controls, and custom icons.
-->
<nav [attr.aria-label]="ariaLabel" >
    <ul 
        class="pagination mb-0"
        [ngClass]="[paginationVariant, classStyleRounded, classStyleSquare, classStyleSize]">

        <!--
            @section Jump to First Row
            @condition jumpButtonInRow
            @description Button to jump to the first group of pages.
        -->
        @if (jumpButtonInRow) {
            <li 
                class="page-item first-in-row"
                [class.disabled]="isFirstPage || frazzled"
                (click)="onFirstPageInRow()">
                <a class="page-link" href="javascript:void(0);" aria-label="First In Row" appWaves>
                    <i [class]="fistRowIcon"></i>
                </a>
            </li>
        }

        <!--
            @section Jump to First Page
            @condition jumpButton
            @description Button to jump to the first page in full list.
        -->
        @if (jumpButton) {
            <li 
                class="page-item first"
                [class.disabled]="indexPage === 0 || frazzled"
                (click)="onFirstPage()">
                <a 
                    appWaves
                    class="page-link"
                    [ngClass]="[bgVariant, textVariant]"
                    style="--bs-bg-opacity: 0.10"
                    aria-label="First"
                    href="javascript:void(0);">
                    @if (firstIcon) {
                        <i [class]="firstIcon"></i>
                    }
                    @else {1}
                </a>
            </li>
        }

        <!--
            @section Previous Button
            @condition navigationButton
            @description Navigate to the previous page.
        -->
        @if (navigationButton) {
            <li class="page-item prev" [class.disabled]="isFirstPage || frazzled" (click)="previousPage()">
                <a class="page-link" href="javascript:void(0);" aria-label="Previous" appWaves>
                    <i [class]="nextIcon"></i>
                </a>
            </li>
        }
        
        <!--
            @section Visible Page Range
            @loop totalPages.slice(indexPage, rows + indexPage)
            @description Renders each visible page button with active state.
        -->
        @for (page of totalPages | slice: indexPage : (rows + indexPage); track page;) {
            <li 
                class="page-item"
                (click)="onPageChange(page)"
                [class.disabled]="frazzled"
                [class.active]="isCurrentPage(page)">
                <a 
                    appWaves
                    class="page-link"
                    href="javascript:void(0);"
                    [attr.aria-current]="isCurrentPage(page) || null">
                    {{page}}
                </a>
            </li>
        }

        <!--
            @section Next Button
            @condition navigationButton
            @description Navigate to the next page.
        -->
        @if (navigationButton) {
            <li class="page-item next" [class.disabled]="isLastPage || frazzled" (click)="nextPage()">
                <a class="page-link" href="javascript:void(0);" aria-label="Next" appWaves>
                    <i [class]="previousIcon"></i>
                </a>
            </li>
        }
        
        <!--
            @section Jump to Last Page
            @condition jumpButton
            @description Button to jump to the last page.
        -->
        @if (jumpButton) {
            <li 
                class="page-item last"
                [class.disabled]="((indexPage + rows) >= totalPages.length) || frazzled" 
                (click)="onLastPage()">
                <a 
                    class="page-link"
                    [ngClass]="[bgVariant, textVariant]"
                    style="--bs-bg-opacity: 0.10" 
                    aria-label="last"
                    href="javascript:void(0);">
                    @if (lastIcon) {
                        <i [class]="lastIcon"></i>
                    }
                    @else {
                        {{lastPage}}
                    }
                </a>
            </li>
        }

        <!--
            @section Jump to Last Row
            @condition jumpButtonInRow
            @description Button to jump to the last group of pages.
        -->
        @if (jumpButtonInRow) {
            <li class="page-item last-in-row" (click)="onLastPageInRow()" [class.disabled]="isLastPage || frazzled">
                <a class="page-link" href="javascript:void(0);" aria-label="Last In Row" appWaves>
                    <i [class]="lastRowIcon"></i>
                </a>
            </li>
        }

    </ul>
    
</nav>